<template>
	<div class="page">
		<div class="container-fluid">
			<div style="display: flex;align-items: flex-end;">
				<span style="font-size: 22px;color:#fff">权朗网络</span>
				<span style="font-size: 16px;color:#B3B3B3;margin-left:5px;margin-bottom: 2px;">v2023</span>
			</div>
			<span style="margin-top: 10px;font-size: 14px;color:#fff">controller network</span>
		</div>
		<div class="list-row">
			<div class="item widget-primary">
				<div style="color: #9cdcf2;font-size: 14px;margin-bottom: 14px;">
					今日收入
				</div>
				<div style="font-size: 26px;color: #fff;font-weight: 300;margin-bottom: 14px;">
					￥{{today.amount}} - {{today.percent_fee}} = {{today.amount-today.percent_fee}}
				</div>
				<div style="color: #9cdcf2;font-size: 14px;padding-top: 14px;">
					昨日收入：￥{{yestoday.amount-yestoday.percent_fee}}
				</div>
			</div>
			<div class="item widget-purple">
				<div style="color: #ded5e7;font-size: 14px;margin-bottom: 14px;">
					本月收入
				</div>
				<div style="font-size: 26px;color: #fff;font-weight: 300;margin-bottom: 14px;">
					￥{{month.amount}} - {{month.percent_fee}} = {{month.amount-month.percent_fee}}
				</div>
				<div style="color: #ded5e7;font-size: 14px;padding-top: 14px;">
					上月收入：￥{{month.amount-month.percent_fee}}
				</div>
			</div>
			<div class="item widget-normal" v-loading="times_loading">
				<div style="color: #ded5e7;font-size: 14px;margin-bottom: 14px;display: flex;align-items: center;justify-content: space-between;">
					当前小时API调用次数次数
					<span class="el-icon-refresh" style="font-size: 18px;color: #ded5e7;cursor: pointer;" @click="api_data_load"></span>
				</div>
				<div style="font-size: 26px;color: #fff;font-weight: 300;margin-bottom: 14px;">
					{{now_hour_api_times}}
				</div>
				<div style="color: #ded5e7;font-size: 14px;padding-top: 14px;">
					24小时最高 API调用：{{hour_max_times}}(非独立服务器，每小时最多可用{{hour_max_times}}次)
				</div>
			</div>
		</div>
		<div class="list-row" style="margin-top: 0px;">
			
			<div style="flex: 2;margin: 0 10px;padding: 10px;min-height: 300px;" class="widget">
				<div class="table-header">
					<span>通告内容</span>
					<span>时间</span>
				</div>
				<div class="table-item" v-for="(item,index) in tableData" :key="index">
					<div class="left">
						<span style="margin-right: 10px;">{{item.title}}</span>
						<el-link :href="item.href" type="primary">点击加入</el-link>
					</div>
					<span>{{item.date}}</span>
				</div>
			</div>
			<div style="flex: 1;margin: 0 10px;height: 180px;" class="widget">
				<div style="padding: 16px 18px;border-bottom: 1px solid #3f4649;">服务到期时间</div>
				<div style="display: flex;justify-content: space-between;padding: 15px;">
					<div style="display: flex;flex-direction: column;align-items: flex-start;">
						<span>{{endtime|formatTime}}</span>
						<div class="s_btn" @click="toCharge">去充值</div>
						<el-link href="#" type="primary" @click.native="dialogVisible=true">查看免费方案</el-link>
					</div>
				</div>
			</div>
		</div>
		<el-dialog
		  title="信息"
		  :visible.sync="dialogVisible"
		  width="90%">
		  <iframe :src="url" frameborder="0" style="width: 100%;height: 700px;"></iframe>
		</el-dialog>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		data(){
			return {
				dialogVisible:false,
				url:'https://shimo.im/docs/dyD9Jkk6pPy9GWxv/read',
				tableData: [{
					date: '2016-05-02',
					title: '官方QQ群【105047820】',
					href: 'http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=7o36sheUpnxzMsgr9sXZjcZV_fo-5GiX&authKey=efl6d1jtnRv4aSI3LpkBHNOOWJqU0mxXKI24ZHWcE%2Buae0BKOG1qlBxalkdyKRP0&noverify=0&group_code=105047820'
				}, {
					date: '2016-05-04',
					title: '【广告】按键精灵飞猪脚本QQ群：【554127455】',
					href: 'https://jq.qq.com/?_wv=1027&k=AIj8fw0T'
				}, {
					date: '2016-05-01',
					title: '权朗网络APP下载地址：http://wz4.cc/app',
					href: 'http://wz4.cc/app'
				}],
				yestoday:{
					amount:0,
					percent_fee:0
				},
				today:{
					amount:0,
					percent_fee:0
				},
				month:{
					amount:0,
					percent_fee:0
				},
				hour_max_times:0,
				now_hour_api_times:0,
				times_loading:false,
				endtime:0
			}
		},
		created() {
			this.updateAmountCount('today')
			this.updateAmountCount('this_month');
			this.updateAmountCount('yestoday');
			this.api_data_load()
		},
		computed: {
			...mapState({
				reload:state=>state.reload
			})
		},
		watch:{
			reload(n,v){
				this.updateAmountCount('today')
				this.updateAmountCount('this_month');
				this.updateAmountCount('yestoday');
				this.api_data_load()
			}
		},
		filters: {
			formatTime(value) {
				if (value == 0) return ''
				let date = new Date(value * 1000)
				var year = date.getFullYear();
				var month = ("0" + (date.getMonth() + 1)).slice(-2);
				var sdate = ("0" + date.getDate()).slice(-2);
				var hour = ("0" + date.getHours()).slice(-2);
				var minute = ("0" + date.getMinutes()).slice(-2);
				var second = ("0" + date.getSeconds()).slice(-2);
				// 拼接
				var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
				// 返回
				return result;
			}
		},
		methods:{
			api_data_load(){
				this.times_loading = true
				this.$H.post('verify_center/v1_0_1.Mine/ApiTimesData').then((res) => {
					this.times_loading = false
					if(res.data){
						this.hour_max_times = res.data.hour_max_times
						this.now_hour_api_times = res.data.now_hour_api_times
					}
				}).catch(err=>{
					this.times_loading = false
				});
				let fields_arr = ['software_num', 'wechat_info', 'center_id', 'endtime', 'not_read_notice_num', 'money',
					'quanlang_id', 'high_data_endtime', 'is_certify', 'ali_real_name', 'wx_openid'
				]
				this.$H.post('verify_center/v1_0_1.Mine/CenterInfo', {
					fields: fields_arr
				}).then(res => {
					if(res.data){
						this.endtime = res.data.endtime
					}
				});
			},
			updateAmountCount(type){
				this.$H.post('verify_center/v1_0_1.Amount/Count',{
					type:type
				}).then(res => {
					if(res.data){
						if(type==='today'){
							this.today.amount = (res.data.count_data.total_fee_sum/100).toFixed(2)
							this.today.percent_fee = (((this.today.amount*res.data.percent_fee)/100)+(res.data.count_data.agent_getmoney_sum/100)+(res.data.count_data.uper_agent_getmoney_sum/100)).toFixed(2)
						}else if(type==='yestoday'){
							this.yestoday.amount = (res.data.count_data.total_fee_sum/100).toFixed(2)
							this.yestoday.percent_fee = (((this.yestoday.amount*res.data.percent_fee)/100)+(res.data.count_data.agent_getmoney_sum/100)+(res.data.count_data.uper_agent_getmoney_sum/100)).toFixed(2)
						}else if(type=='this_month'){
							this.month.amount = (res.data.count_data.total_fee_sum/100).toFixed(2)
							this.month.percent_fee = (((this.month.amount*res.data.percent_fee)/100)+(res.data.count_data.agent_getmoney_sum/100)+(res.data.count_data.uper_agent_getmoney_sum/100)).toFixed(2)
						}
					}
				});
			},
			toCharge(){
				this.$router.push({
					name:'charge'
				})
			}
		}
   }
</script>

<style>
	.page {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		flex-direction: column;
	}

	.page .container-fluid {
		padding: 40px 20px;
		display: flex;
		flex-direction: column;
		background-color: rgb(66, 75, 79)
	}

	.page .list-row {
		display: flex;
		padding: 20px 10px;
	}

	.page .list-row .item {
		flex: 1;
		margin: 0 10px;
		padding: 30px 17px;
		color: #ffffff;
		display: flex;
		flex-direction: column;
	}

	.widget-primary {
		border: 1px solid #11627d;
		border-top: 2px solid #105f79;
		background: #1786aa;

	}

	.widget-purple {
		border: 1px solid #5e4578;
		border-top: 2px solid #5c4375;
		background: #785799;
	}

	.widget-normal {
		background: #7744FF;
		border: 1px solid #7744FF;
		border-top: 2px solid #7744FF;
	}

	.widget {
		border: 1px solid #33393c;
		border-top: 2px solid #313639;
		background: #4b5357;
		color: #ffffff;
	}
	.table-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding: 14px 12px;
		font-weight: 700;
	}
	.table-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding: 14px 12px;
		border-top: 1px solid #666d70;
		cursor:pointer;
	}
	.table-item:hover{
		background-color: #1786aa;
	}
	.table-item .left{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		flex: 1;
	}
	.s_btn{
		border: 1px solid #fff;
		padding: 5px 5px;
		width: 60px !important;
		margin: 10px 0 ;
		background-color: #4b5357 ;
		color: #fff ;
		font-size: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor:pointer;
	}
	.s_btn:hover{
		color: #55aaff !important;
		background-color: #ccc !important;
		border: 1px solid #ccc !important;
	}
</style>